export default __webpack_public_path__ + "media/images/mailer/icon_link-00336a47707d179b93f20fbc9f185dfd.png";